import { QueryClient } from '@tanstack/react-query'

/** Singleton QueryClient для admin app.
 *  Дефолты:
 *    - retry: 1 (для GET) / 0 (для mutations) — backend ошибки чаще всего детерминированы.
 *    - staleTime: 30s — для большинства admin-данных это норма.
 *    - refetchOnWindowFocus: false — admin desktop, не нужно re-fetch'ить при alt-tab. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
})
